/**
 * IP18 Grip / 4K — mobile pin: Part 1 hero fades; Part 2+3 rise as one layer.
 * PC and reduced-motion stay sequential.
 */
(function () {
  'use strict';

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function mapRange(p, a0, a1) {
    if (p <= a0) return 0;
    if (p >= a1) return 1;
    return (p - a0) / (a1 - a0);
  }

  function easeInOut(t) {
    return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  }

  class Ip18GripPin extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this._hero = this.querySelector('[data-ip18-grip-hero]');
      this._mask = this.querySelector('[data-ip18-grip-mask]');
      this._rise = this.querySelector('[data-ip18-grip-rise]');
      this._desktop = window.matchMedia('(min-width: 1024px)');
      this._reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._onScroll = this._onScroll.bind(this);
      this._onMode = this._onMode.bind(this);

      this._desktop.addEventListener('change', this._onMode);
      this._reduce.addEventListener('change', this._onMode);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this._applyMode();
      this._onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
      if (this._desktop) this._desktop.removeEventListener('change', this._onMode);
      if (this._reduce) this._reduce.removeEventListener('change', this._onMode);
    }

    _shouldPin() {
      return !this._desktop.matches && !this._reduce.matches && this._hero && this._rise;
    }

    _reset() {
      if (this._hero) {
        this._hero.style.opacity = '';
        this._hero.style.pointerEvents = '';
      }
      if (this._mask) this._mask.style.opacity = '';
      if (this._rise) this._rise.style.removeProperty('--ip18-grip-rise-a');
    }

    _applyMode() {
      var pin = this._shouldPin();
      this.classList.toggle('is-pin', pin);
      this.classList.toggle('is-reduced', !pin);
      if (!pin) this._reset();
    }

    _onMode() {
      this._applyMode();
      this._onScroll();
    }

    _onScroll() {
      if (!this._shouldPin()) return;

      var vh = window.innerHeight || 1;
      var cover = 1 - this._rise.getBoundingClientRect().top / vh;
      var t = easeInOut(mapRange(cover, 0, 1));
      var a = easeInOut(mapRange(cover, 0.5, 1.15));

      this._hero.style.opacity = String(1 - t);
      this._hero.style.pointerEvents = t > 0.95 ? 'none' : '';
      if (this._mask) this._mask.style.opacity = String(t);
      this._rise.style.setProperty('--ip18-grip-rise-a', String(a));
    }
  }

  if (!customElements.get('ip18-grip-pin')) {
    customElements.define('ip18-grip-pin', Ip18GripPin);
  }
})();
